module.exports = __webpack_public_path__ + "static/media/export-credit.b194a5c7.png";